import { AnchoringAweighData } from "../../../entities";
import OldRecordsParser from "../OldRecordsParser";
import PropTransformer from "../PropTransformer";
import { FIXED_PROTOCOL_CONTENT_TYPE_IDS, FIXED_PROTOCOL_TYPE_IDS } from "../../../utils/ProtocolTypeUtils";
const dataTag = 'AnchoringAweighData';
export default class AnchoringAweighParser extends OldRecordsParser {
    constructor(app) {
        super(FIXED_PROTOCOL_TYPE_IDS.ANCHORING_AWEIGH, FIXED_PROTOCOL_CONTENT_TYPE_IDS.ANCHORING_AWEIGH, dataTag, app);
    }
    getPropsMapping() {
        return {
            anchor: 'anchor',
            freeText: 'freeText',
        };
    }
    createData(props, record) {
        const data = new AnchoringAweighData(props.anchor, props.freeText);
        const linked = this.getLinked(record);
        if (linked) {
            const link = {
                protocol: linked,
                value: props.anchor,
            };
            data.anchor = link;
        }
        return data;
    }
}
//# sourceMappingURL=AnchoringAweighParser.js.map